module.exports = __webpack_public_path__ + "static/green_slaad-223c3a4d92689b966cdcfc3ae9b1f023.jpg";